const enabled = process.env.REACT_APP_ENABLE_SESSION_RECORDING === "true";
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

export function initSessionRecording() {
  if (!enabled || !posthogKey) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.src = `${posthogHost.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
  script.onload = () => {
    if (!window.posthog || typeof window.posthog.init !== "function") {
      return;
    }
    window.posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: "identified_only",
      session_recording: {
        recordCrossOriginIframes: false,
        capturePerformance: false,
      },
    });
  };
  document.head.appendChild(script);
}
